export default __webpack_public_path__ + "static/media/es-ib.d86f0c41.svg";